import { formatRut } from "./displayFormat";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const EMPRESA_NOTA_COBRO = {
  "76.071.007-5": {
    nombre: "ALTAMIRA S.A.",
    encabezado: "ALTAMIRA",
    direccion: "Alcalde Guzmán #0121, Quilicura",
    telefono: "+56 2 2580-2148",
    email: "administracion@pevn.cl",
    banco: "BANCO ITAU",
    cuenta: "212099106",
    tipoCuenta: "Cuenta Corriente",
  },
  "76.066.122-8": {
    nombre: "SOC AGRIC E INMOBILIARIA LA SIEMBRA LTDA",
    encabezado: "LA SIEMBRA",
    direccion: "No disponible",
    telefono: "No disponible",
    email: "No disponible",
    banco: "BANCO ITAU",
    cuenta: "223286902",
    tipoCuenta: "Cuenta Corriente",
  },
};

const normalizar = (v = "") => String(v).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const generateNotaDeCobroPDF = (baseUrl, rowData, formatNumber, formatNumberUf, formatDate, mes, anio) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const rutEmpresaRaw = rowData.rutEmpresa || rowData.rut_empresa || "";
  const rutEmpresa = formatRut(rutEmpresaRaw);
  const empresa = EMPRESA_NOTA_COBRO[rutEmpresa] || {
    nombre: rowData.descripcionEmpresa || rowData.empresa || "Empresa arrendadora",
    encabezado: rowData.descripcionEmpresa || rowData.empresa || "EMPRESA",
    direccion: "No disponible", telefono: "No disponible", email: "No disponible",
    banco: "No disponible", cuenta: "No disponible", tipoCuenta: "No disponible"
  };
  const cliente = rowData.nombreCliente || rowData.cliente || "No disponible";
  const rutCliente = formatRut(rowData.rutCliente || rowData.rut_cliente || "");
  const folioRaw = rowData.folio || rowData.n_documento;
  const folio = Number(folioRaw) > 0 ? String(Math.trunc(Number(folioRaw))) : "No disponible";
  const fechaEmision = formatDate(rowData.fechaEmision || rowData.fecha_emision) || "No disponible";
  const fechaVencimiento = formatDate(rowData.fechaVencimiento || rowData.fecha_vencimiento) || "No disponible";
  const fechaUf = formatDate(rowData.fechaValorUf || rowData.fecha_valor_uf) || rowData.fechaValorUf || rowData.fecha_valor_uf || "No disponible";
  const valorUf = Number(rowData.valorUf || rowData.valor_uf || 0);
  const detalles = rowData.detallesCobro || rowData.detalleCobro || [];
  const mesNombre = new Date(Number(anio), Number(mes) - 1, 1).toLocaleString("es-CL", { month: "long" }).toUpperCase();
  const total = detalles.reduce((s,d) => s + Number(d.unitario || 0) * Number(d.cantidad || 0), 0);
  const totalUf = valorUf > 0 ? total / valorUf : 0;
  const esGastoComun = detalles.some(d => normalizar(d.glosa).includes("gasto comun"));
  const tituloCobro = esGastoComun ? "GASTO COMÚN" : (detalles[0]?.glosa || "COBRO").toUpperCase();

  const pageW = pdf.internal.pageSize.getWidth();
  const left = 9;
  const right = pageW - 9;
  const width = right - left;
  const box = (x, y, w, h) => {
    // jsPDF conserva el estado gráfico. Fijamos el relleno antes de CADA caja
    // para evitar los bloques negros que aparecían en algunos visores.
    pdf.setFillColor(249, 249, 249);
    pdf.setDrawColor(220, 220, 220);
    pdf.setLineWidth(0.2);
    pdf.rect(x, y, w, h, "FD");
  };

  // Marco y cabecera
  pdf.setDrawColor(45, 45, 45);
  pdf.setLineWidth(0.45);
  pdf.rect(6, 5, pageW - 12, 287);
  pdf.setTextColor(35, 35, 35);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(15);
  pdf.text(empresa.encabezado, pageW / 2, 16, { align: "center" });
  pdf.setFontSize(10.5);
  pdf.text(`N°: ${folio}`, right - 2, 16, { align: "right" });
  pdf.setDrawColor(220, 220, 220);
  pdf.setLineWidth(0.2);
  pdf.line(left, 22, right, 22);

  pdf.setFontSize(10.5);
  pdf.text("NOTA DE COBRO", 11, 30);
  pdf.text(tituloCobro, 11, 39);

  // Datos de la arrendadora a la derecha; el logo queda en una columna propia.
  const logoX = 176;
  const companyRight = 173;
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8.8);
  pdf.text("Bodegas CBQ", companyRight, 29, { align: "right" });
  pdf.text(empresa.direccion, companyRight, 34, { align: "right" });
  pdf.text(`Teléfono: ${empresa.telefono}`, companyRight, 39, { align: "right" });
  pdf.text(empresa.email, companyRight, 44, { align: "right" });
  try { pdf.addImage(`${window.location.origin}/logoCBQ.png`, "PNG", logoX, 26, 18, 11); } catch(e) {}
  pdf.line(left, 53, right, 53);

  // Cliente / fechas
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(8.8);
  pdf.text("A:", 11, 61);
  pdf.text(cliente.toUpperCase(), 11, 69);
  pdf.text(rutCliente || "RUT no disponible", 11, 74);

  pdf.text("Fecha Emisión:", 84, 63);
  pdf.setFont("helvetica", "normal");
  pdf.text(fechaEmision, 108, 63);
  pdf.setFont("helvetica", "bold");
  pdf.text("Fecha Vencimiento:", 132, 63);
  pdf.setFont("helvetica", "normal");
  pdf.text(fechaVencimiento, 166, 63);
  pdf.setFont("helvetica", "bold");
  pdf.text("Mes:", 84, 72);
  pdf.setFont("helvetica", "normal");
  pdf.text(mesNombre, 108, 72);
  pdf.setFont("helvetica", "bold");
  pdf.text(String(anio), 132, 72);

  const body = detalles.length
    ? detalles.map(d => [d.glosa || "Detalle", `$${formatNumber(Number(d.unitario || 0) * Number(d.cantidad || 0))}`])
    : [["Sin detalle", "$0"]];
  pdf.autoTable({
    startY: 81,
    margin: { left, right: 9 },
    head: [["Detalle", "Monto a Cancelar"]],
    body,
    theme: "grid",
    styles: { font: "helvetica", fontSize: 9.5, cellPadding: 2.8, lineColor: [225,225,225], lineWidth: 0.15, textColor: [55,55,55] },
    headStyles: { fillColor: [247,247,247], textColor: [45,45,45], fontStyle: "bold" },
    columnStyles: { 0: { cellWidth: 78 }, 1: { cellWidth: width - 78 } }
  });

  // La referencia original deja aire entre el detalle y los recuadros inferiores.
  let y = Math.max(pdf.lastAutoTable.finalY + 10, 151);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(9.5);
  box(left, y, width, 8);
  pdf.text(`El presente cobro corresponde a ${formatNumberUf(totalUf)} UF`, left + 2, y + 5.4);
  y += 10;
  box(left, y, width, 8);
  pdf.text(`Valor UF al: ${fechaUf}  $${formatNumberUf(valorUf)}`, left + 2, y + 5.4);
  y += 10;

  if (esGastoComun) {
    box(left, y, width, 34);
    pdf.setFont("helvetica", "bold");
    pdf.text("El cobro de gastos comunes incluye:", left + 3, y + 7);
    pdf.setFont("helvetica", "normal");
    // Se usa guion ASCII en vez de bullet Unicode: Helvetica de jsPDF no
    // incorpora ese glifo de forma fiable y algunos lectores lo renderizan mal.
    pdf.text("- Iluminación común", left + 3, y + 14);
    pdf.text("- Vigilancia permanente 24 x 7.", left + 3, y + 19);
    pdf.text("- Mantención de áreas verdes y espacios comunes.", left + 3, y + 24);
    pdf.text("- Aseo de áreas comunes.", left + 3, y + 29);
    y += 36;
  }

  box(left, y, width, 37);
  pdf.setFont("helvetica", "bold");
  pdf.text("Notas: Páguese hasta los primeros 5 días de cada mes.", left + 3, y + 7);
  pdf.setFont("helvetica", "normal");
  pdf.text(`Se puede cancelar con depósito y/o transferencia bancaria al ${empresa.banco} N° ${empresa.cuenta}`, left + 3, y + 16);
  pdf.text(`Razón Social ${empresa.nombre}. RUT: ${rutEmpresa}`, left + 3, y + 23);
  pdf.text(`Cuenta: ${empresa.tipoCuenta}`, left + 3, y + 30);

  return pdf.output("blob");
};

export const generateEstadoDeCuentaPDF = (
  baseUrl,
  rowData,
  formatNumber,
  formatNumberUf,
  formatDate,
  mes,
  anio
) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const docs = Array.isArray(rowData?.documentos) ? rowData.documentos : [];
  const firstDoc = docs[0] || {};
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 12;
  const contentWidth = pageWidth - margin * 2;
  const money = (value) => `$ ${formatNumber(Math.round(Number(value || 0)))}`;
  const uf = (value) => formatNumberUf(Number(value || 0));
  const clean = (value, fallback = "No informado") => value !== null && value !== undefined && String(value).trim() ? String(value) : fallback;
  const tipo = (doc) => String(doc?.tipoDocumento || "").toLowerCase();
  const esAfecta = (doc) => tipo(doc) === "factura afecta";
  const totalDetalle = (d) => Number(d?.unitario || 0) * Number(d?.cantidad || 1);
  const normalizar = (value) => String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const categoria = (glosa) => {
    const g = normalizar(glosa);
    if (g.includes("arriendo")) return "Arriendo(s)";
    if (g.includes("gasto comun")) return "Gasto Común";
    if (["agua", "electricidad", "internet", "servicio"].some((x) => g.includes(x))) return "Servicios";
    if (["obra civil", "habilitacion", "instalacion"].some((x) => g.includes(x))) return "Obras Civiles";
    if (g.includes("descuento")) return "Descuentos";
    return "Otros";
  };

  const items = docs.flatMap((doc) => (Array.isArray(doc.detallesCobro) ? doc.detallesCobro : []).map((d) => ({
    ...d,
    documento: doc,
    neto: totalDetalle(d),
    categoria: categoria(d.glosa),
  })));
  const conIva = items.filter((i) => esAfecta(i.documento));
  const sinIva = items.filter((i) => !esAfecta(i.documento));
  const subtotal = (arr, cat) => arr.filter((i) => i.categoria === cat).reduce((a, i) => a + i.neto, 0);
  const netoConIva = conIva.reduce((a, i) => a + i.neto, 0);
  const ivaConIva = netoConIva * 0.19;
  const totalConIva = netoConIva + ivaConIva;
  const totalSinIva = sinIva.reduce((a, i) => a + i.neto, 0);
  const totalGeneral = totalConIva + totalSinIva;
  const totalUf = Number(firstDoc.valorUf || 0) > 0 ? totalGeneral / Number(firstDoc.valorUf) : 0;

  const empresaNombre = clean(firstDoc.descripcionEmpresa || rowData.nombreEmpresa, "Empresa arrendadora");
  const empresaRut = formatRut(rowData.rutEmpresa || firstDoc.rutEmpresa || "");
  const clienteNombre = clean(rowData.nombreCliente || firstDoc.nombreCliente);
  const clienteAlias = clean(rowData.aliasCliente, "");
  const clienteRut = formatRut(rowData.rutCliente || firstDoc.rutCliente || "");
  const numeroEstado = clean(rowData.numeroEstado, "S/N");
  const fechaEmision = formatDate(firstDoc.fechaEmision) || "No informada";
  const fechaVencimiento = formatDate(firstDoc.fechaVencimiento) || "No informada";
  const fechaUf = firstDoc.fechaValorUf || "No informada";
  const valorUf = Number(firstDoc.valorUf || 0);
  const monthName = new Date(Number(anio), Number(mes) - 1, 1).toLocaleString("es-CL", { month: "long" });
  const periodo = `${monthName.charAt(0).toUpperCase()}${monthName.slice(1)} ${anio}`;

  const companyBank = (() => {
    const rut = String(rowData.rutEmpresa || firstDoc.rutEmpresa || "").replace(/\./g, "");
    if (rut === "76.071.007-5" || rut === "76071007-5") return { banco: "Banco Itaú", cuenta: "212099106", titular: "ALTAMIRA S.A.", rut: "76.071.007-5", tipo: "Cuenta Corriente" };
    if (rut === "76.066.122-8" || rut === "76066122-8") return { banco: "Banco Itaú", cuenta: "223286902", titular: "SOC AGRIC E INMOBILIARIA LA SIEMBRA LTDA", rut: "76.066.122-8", tipo: "Cuenta Corriente" };
    return { banco: "No informado", cuenta: "No informada", titular: empresaNombre, rut: empresaRut, tipo: "No informado" };
  })();

  const addLogo = () => {
    try {
      const logoUrl = rowData.logoEmpresa || `${window.location.origin}/logoCBQ.png`;
      pdf.addImage(logoUrl, "PNG", margin, 10, 31, 20);
    } catch (e) {
      // El PDF sigue siendo válido si el navegador no puede resolver el logo.
    }
  };
  addLogo();

  pdf.setTextColor(35, 35, 35);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(18);
  pdf.text("Estado de Cuenta", pageWidth / 2, 20, { align: "center" });
  pdf.setFontSize(10);
  pdf.setTextColor(90, 90, 90);
  pdf.text(periodo.toUpperCase(), pageWidth / 2, 27, { align: "center" });

  pdf.setDrawColor(90, 90, 90);
  pdf.roundedRect(pageWidth - margin - 52, 10, 52, 21, 1.5, 1.5);
  pdf.setTextColor(35, 35, 35);
  pdf.setFontSize(9);
  pdf.text(`RUT: ${empresaRut}`, pageWidth - margin - 49, 18);
  pdf.text(`N° Documento: ${numeroEstado}`, pageWidth - margin - 49, 25);

  let y = 38;
  pdf.setFontSize(10);
  pdf.setFont("helvetica", "bold");
  pdf.text(empresaNombre.toUpperCase(), pageWidth / 2, y, { align: "center" });
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(8.5);
  pdf.setTextColor(90, 90, 90);
  pdf.text(`RUT ${empresaRut}`, pageWidth / 2, y + 5, { align: "center" });

  y += 13;
  const infoBody = [
    ["Cliente", clienteNombre, "Fecha emisión", fechaEmision],
    ["RUT", clienteRut, "Fecha vencimiento", fechaVencimiento],
    ["Alias", clienteAlias || "-", "Valor UF", money(valorUf)],
    ["Asignación", clean(rowData.descripcionGrupo, "-"), "Fecha UF", fechaUf],
  ];
  pdf.autoTable({
    startY: y,
    body: infoBody,
    theme: "grid",
    styles: { fontSize: 8.5, cellPadding: 2.2, lineColor: [220, 220, 220], lineWidth: 0.15 },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 25 }, 1: { cellWidth: 68 }, 2: { fontStyle: "bold", cellWidth: 31 }, 3: { cellWidth: 62 } },
  });
  y = pdf.lastAutoTable.finalY + 8;

  const summaryRows = (arr, includeIva) => {
    const cats = ["Arriendo(s)", "Gasto Común", "Servicios", "Obras Civiles", "Otros", "Descuentos"];
    const rows = cats.map((c) => [c, money(subtotal(arr, c))]).filter((r) => r[1] !== "$ 0" || ["Arriendo(s)", "Gasto Común", "Servicios", "Obras Civiles"].includes(r[0]));
    const net = arr.reduce((a, i) => a + i.neto, 0);
    if (includeIva) {
      rows.push(["SUBTOTAL", money(net)]);
      rows.push(["IVA 19%", money(net * 0.19)]);
      rows.push(["TOTAL C/IVA", money(net * 1.19)]);
    } else rows.push(["TOTAL", money(net)]);
    return rows;
  };

  const leftRows = summaryRows(conIva, true);
  const rightRows = summaryRows(sinIva, false);
  const summaryY = y;
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10.5);
  pdf.setTextColor(35, 35, 35);
  pdf.text("Resumen de cobros · CON IVA", margin, summaryY);
  pdf.text("Resumen de cobros · SIN IVA", margin + 98, summaryY);
  const drawSummary = (x, rows) => pdf.autoTable({
    startY: summaryY + 3,
    margin: { left: x },
    tableWidth: 88,
    head: [["Ítem", "Monto"]],
    body: rows,
    theme: "plain",
    styles: { fontSize: 8.5, cellPadding: 1.5 },
    headStyles: { fontStyle: "bold", fillColor: [235, 235, 235], textColor: [35, 35, 35] },
    columnStyles: { 1: { halign: "right" } },
    didParseCell: (data) => {
      if (data.section === "body" && ["TOTAL", "TOTAL C/IVA"].includes(String(data.cell.raw))) data.cell.styles.fontStyle = "bold";
    },
  });
  drawSummary(margin, leftRows);
  const leftEnd = pdf.lastAutoTable.finalY;
  drawSummary(margin + 98, rightRows);
  y = Math.max(leftEnd, pdf.lastAutoTable.finalY) + 9;

  const ensureSpace = (needed = 30) => {
    if (y + needed > pageHeight - 15) { pdf.addPage(); y = 18; }
  };
  const detailTable = (title, rows, head, widths = {}) => {
    ensureSpace(35);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10.5);
    pdf.text(title, margin, y);
    pdf.autoTable({
      startY: y + 3,
      head: [head],
      body: rows.length ? rows : [["NO APLICA", ...Array(head.length - 1).fill("")]],
      theme: "striped",
      styles: { fontSize: 7.5, cellPadding: 1.7, overflow: "linebreak" },
      headStyles: { fillColor: [195, 195, 195], textColor: [255, 255, 255], fontStyle: "bold", halign: "center" },
      columnStyles: widths,
      margin: { left: margin, right: margin },
    });
    y = pdf.lastAutoTable.finalY + 8;
  };

  const detailRows = (cats) => items.filter((i) => cats.includes(i.categoria)).map((i) => {
    const net = i.neto;
    const ivaValue = esAfecta(i.documento) ? net * 0.19 : 0;
    const total = net + ivaValue;
    return [clean(i.glosa, "-"), clean(i.documento.tipoDocumento, "-"), clean(i.documento.folio, "-"), money(net), money(ivaValue), money(total)];
  });
  detailTable("Detalle Arriendos", detailRows(["Arriendo(s)"]), ["Ítem", "Doc. cobro", "Folio", "Neto", "IVA", "Total"]);

  const serviceRows = items.filter((i) => i.categoria === "Servicios").map((i) => {
    const net = i.neto;
    const ivaValue = esAfecta(i.documento) ? net * 0.19 : 0;
    return [clean(i.glosa, "-"), clean(i.lecturaInicial, "-"), clean(i.lecturaFinal, "-"), clean(i.cantidad, "-"), clean(i.unidadMedida, "-"), clean(i.documento.tipoDocumento, "-"), clean(i.documento.folio, "-"), money(net + ivaValue)];
  });
  detailTable("Detalle Servicios", serviceRows, ["Servicio", "Lect. inicial", "Lect. final", "Consumo", "Unidad", "Doc. cobro", "Folio", "Total"]);
  detailTable("Detalle Gasto Común", detailRows(["Gasto Común"]), ["Ítem", "Doc. cobro", "Folio", "Neto", "IVA", "Total"]);
  detailTable("Detalle Obras Civiles e Instalaciones", detailRows(["Obras Civiles", "Otros"]), ["Ítem", "Doc. cobro", "Folio", "Neto", "IVA", "Total"]);

  ensureSpace(34);
  pdf.autoTable({
    startY: y,
    margin: { left: 92 },
    tableWidth: 106,
    body: [
      ["Neto afecto", money(netoConIva)],
      ["IVA", money(ivaConIva)],
      ["Total sin IVA", money(totalSinIva)],
      ["TOTAL ESTADO DE CUENTA", money(totalGeneral)],
      ["TOTAL UF", valorUf > 0 ? `${uf(totalUf)} UF` : "-"],
    ],
    theme: "grid",
    styles: { fontSize: 8.5, cellPadding: 2 },
    columnStyles: { 0: { fontStyle: "bold" }, 1: { halign: "right" } },
  });
  y = pdf.lastAutoTable.finalY + 8;

  ensureSpace(48);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10.5);
  pdf.text("Información para transferencias o depósitos", margin, y);
  pdf.autoTable({
    startY: y + 3,
    body: [
      ["Titular", companyBank.titular, "Banco", companyBank.banco],
      ["RUT", companyBank.rut, "Tipo de cuenta", companyBank.tipo],
      ["N° de cuenta", companyBank.cuenta, "Referencia", `Estado de Cuenta N° ${numeroEstado}`],
    ],
    theme: "grid",
    styles: { fontSize: 8, cellPadding: 2, lineColor: [220, 220, 220] },
    columnStyles: { 0: { fontStyle: "bold", cellWidth: 23 }, 1: { cellWidth: 65 }, 2: { fontStyle: "bold", cellWidth: 27 }, 3: { cellWidth: 71 } },
  });
  y = pdf.lastAutoTable.finalY + 7;

  ensureSpace(45);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(9.5);
  pdf.text("Notas", margin, y);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(7.8);
  const notes = [
    "Los documentos tributarios asociados a este estado de cuenta se entregan de forma separada.",
    "El valor de la UF corresponde a la fecha indicada en este documento.",
    "Para identificar correctamente el pago, indique el número del estado de cuenta en la transferencia.",
  ];
  notes.forEach((n, idx) => pdf.text(`${idx + 1}. ${n}`, margin, y + 5 + idx * 4.5));
  y += 21;
  pdf.setDrawColor(215, 215, 215);
  pdf.line(margin, y, pageWidth - margin, y);
  pdf.setFontSize(7.5);
  pdf.setTextColor(100, 100, 100);
  pdf.text(`${empresaNombre} · RUT ${empresaRut}`, margin, y + 5);
  pdf.text(`Estado de Cuenta N° ${numeroEstado} · ${periodo}`, pageWidth - margin, y + 5, { align: "right" });

  return pdf.output("blob");
};
